import { render, staticRenderFns } from "./ConfiscateEquipment.vue?vue&type=template&id=38d6a18b"
import script from "./ConfiscateEquipment.vue?vue&type=script&lang=js"
export * from "./ConfiscateEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports